import getDateFromAPIPagos from "@helpers/dates/getDateFromAPIPagos/getDateFromAPIPagos";
import getPrecioFormateado from "@helpers/formateoPrecios/getPreciosFormateado";

const columns = [
  {
    name: "Feha del pago", //nombre de la columna
    selector: (row) => getDateFromAPIPagos(row.fechaPago),
    sortable: true,
  },
  {
    name: "Medio de pago",
    selector: (row) => row.medioPago,
    sortable: true,
    center: true,
  },
  {
    name: "Concepto", //nombre de la columna
    selector: (row) => row.conceptoPago, //identificador de la columna
    sortable: true,
    center: true,
  },
  {
    name: "Referencia", //nombre de la columna
    selector: (row) => row.referenciaPago,
    sortable: true,
  },
  {
    name: "Monto",
    selector: (row) => `$ ${getPrecioFormateado(row.montoPago)}`,
    sortable: true,
    center: true,
  },
];

export default columns;
